<script>
  import {selectWhereKey} from "../modules/selectWhere.js";
  export let footerStuff;
 let contactTitle = selectWhereKey(footerStuff, "contactTitle" );
// console.log("contactTitle",contactTitle);
 let contactEmail  = selectWhereKey(footerStuff, "contactEmail" );
let contactEmailCopy = selectWhereKey(footerStuff, "contactEmailCopy" );
 let newsLetterTitle = selectWhereKey(footerStuff, "newsLetterTitle" );
 let newsLetterLink= selectWhereKey(footerStuff, "newsLetterLink" );
let twitterTitle = selectWhereKey(footerStuff, "twitterTitle" );
 let twitterLink = selectWhereKey(footerStuff, "twitterLink" );
let gdprTitle = selectWhereKey(footerStuff, "gdprTitle" );
 let gdprLink = selectWhereKey(footerStuff, "gdprLink" );
 let privacyPolicyTitle = selectWhereKey(footerStuff, "privacyPolicyTitle" );
let privacyPolicyLink = selectWhereKey(footerStuff, "privacyPolicyLink" );
let companyDetailsTitle = selectWhereKey(footerStuff, "companyDetailsTitle" );
let companyDetailsCopy = selectWhereKey(footerStuff, "companyDetailsCopy" );
let tacTitle = selectWhereKey(footerStuff, "tacTitle");
let tacLink = selectWhereKey(footerStuff, "tacLink");
let nationalLotto = selectWhereKey(footerStuff, "nationalLotto");
let baseURL ="https://strapi.understory.community";
let imgURL = baseURL + nationalLotto.formats.small.url;

</script>

<footer role="contentinfo" class="fic--footer_final">
    <nav class="fic--contact-links ">    

      <div class="fic--contact-links_contact">
        <h2 class="h-e">{contactTitle}</h2>

        <ul> 
          <li>
            <a href="{contactEmail}" title="email us" role="link">
              <!--<svg class="icon icon-envelop"><use xlink:href="#icon-envelop"></use></svg>-->
              <span class="name">{contactEmailCopy}</span>
            </a>
          </li>
        
          <li>
            <a href="{newsLetterLink}" title="{newsLetterTitle}" role="link">
              <!--<svg class="icon icon-mailchimp"><use xlink:href="#icon-mailchimp"></use></svg>-->
              <span class="name">{newsLetterTitle}</span>
            </a>
          </li>
          <li>
            <a href="{twitterLink}" title="{twitterTitle}" role="link">
              <!--<svg class="icon icon-twitter"><use xlink:href="#icon-twitter"></use></svg>-->
              <span class="name">{twitterTitle}</span>
            </a>
          </li>
        </ul>
      </div>
      <div  class="fic--contact-links_legal">
        <ul>
          <h2 class="h-e">Legal.</h2>
          <!-- <li>
            <a href="{gdprLink}" title="{gdprTitle}">{gdprTitle}</a>
          </li> -->
              <li>
                 <img src="{imgURL}" />
              </li>
          <li class="first">
            <a href="{privacyPolicyLink}" title="{privacyPolicyTitle}" role="link">{privacyPolicyTitle}</a>
          </li>
          <li>
              <a href="{tacLink}" title="{tacTitle}" role="link">{tacTitle}</a>
          </li>
        </ul>
      </div>
      <div class="fic--status">
        <span>{companyDetailsTitle}:</span> 
        {companyDetailsCopy}
      </div>
     <!-- <div class="fic--lotto">
          <ul>
              <li>
                 <img src="{imgURL}" />
              </li>
              </ul>
       </div>-->
      <div class="fic--c">
          <ul>
              <li>
                © Free Ice Cream 2021
              </li>
          </ul>
      </div>

    </nav>
  </footer>
  